<article class="company-publication">
  <header class="company-publication__header">
    <div
      class="company-publication__picture"
      [class.fallback]="!model.imageFileUrl"
      [style.backgroundImage]="publicationImage"
    ></div>
    <h1 *ngIf="companyName" class="company-publication__title">
      <a [routerLink]="companyUrl" appEventTracker eventCategory="Search Companies" eventAction="Click Company News">
        {{ model.companyName }}
      </a>
    </h1>

    <h2 *ngIf="model.attachmentTitle" class="company-publication__sub-title">
      {{ model.attachmentTitle }}
    </h2>
  </header>

  <section class="company-publication__content">
    {{ model.content }}
  </section>

  <footer class="company-publication__footer">
    <a
      class="company-publication__link"
      [href]="model.link"
      target="_blank"
      rel="noopener"
      i18n
      appEventTracker
      eventCategory="Search Companies"
      eventAction="Click News"
    >
      Voir la publication&nbsp;<app-svg-icon icon="arrow-right" width="1em"></app-svg-icon>
    </a>
  </footer>
</article>
